export default function FourZeroFourTemplate({ page, renderSections }) {
  return <div>{renderSections()}</div>;
}

FourZeroFourTemplate.displayName = 'FourZeroFourTemplate';
